import cardValidator from 'card-validator'

import { logAndCaptureException } from '../../utils/errorTools'

/**
 * Map of card types from `credit-card-type` NPM module to CyberSource card type
 */
const cardTypeMapping: Partial<Record<string, string>> = {
  'american-express': '003',
  'diners-club': '005',
  discover: '004',
  jcb: '007',
  mastercard: '002',
  visa: '001',
}

export const cyberSourceCardTypeFromNumber = (cardNumber: string): string | undefined => {
  const { card: validatedCard } = cardValidator.number(cardNumber)
  if (!validatedCard) {
    return undefined
  }

  const mappedType = cardTypeMapping[validatedCard.type]
  if (!mappedType) {
    logAndCaptureException(new Error(`Card type not mapped: ${validatedCard.type}`))
    return undefined
  }
  return mappedType
}
